import {
  DeployabilityDay,
  DeployabilityOption,
  DriverDeployabilityDayNote,
  DriverDeployabilityOption
} from '../../../../core-module/services/absence/types';

export const findDeployabilityOption = (
  deployabilityOptions: DeployabilityOption[],
  deployabilityDayId: number,
  deployabilityDayMomentId: number
) => {
  return deployabilityOptions.find(
    (option) =>
      option.deployabilityDayId === deployabilityDayId &&
      option.deployabilityDayMomentId === deployabilityDayMomentId
  );
};

export const findDriverNoteByDeployabilityDay = (
  driverDeployabilityDayNotes: DriverDeployabilityDayNote[],
  deployabilityDay: DeployabilityDay
) => {
  return driverDeployabilityDayNotes.find(
    (note) => note.deployabilityDayId === deployabilityDay.id
  );
};

export const findDriverToDeployabilityOption = (
  driverToDeployabilityOptions: DriverDeployabilityOption[],
  deployabilityOption: DeployabilityOption
) => {
  return driverToDeployabilityOptions.find(
    (driverDeployability) =>
      driverDeployability.deployabilityOption.deployabilityDayId ===
        deployabilityOption.deployabilityDayId &&
      driverDeployability.deployabilityOption.deployabilityDayMomentId ===
        deployabilityOption.deployabilityDayMomentId
  );
};

export const getAllUnselectedOptionsForADay = (
  driverToDeployabilityOptions: DriverDeployabilityOption[],
  deployabilityOptions: DeployabilityOption[]
): DeployabilityOption[] => {
  const unselectedOptions: DeployabilityOption[] = [];

  for (const deployabilityOption of deployabilityOptions) {
    const found = findDriverToDeployabilityOption(
      driverToDeployabilityOptions,
      deployabilityOption
    );
    if (!found) {
      unselectedOptions.push(deployabilityOption);
    }
  }

  return unselectedOptions;
};

export const getDriverDeployabilityOptionsForADay = (
  driverToDeployabilityOptions: DriverDeployabilityOption[],
  deployabilityOptions: DeployabilityOption[]
): DriverDeployabilityOption[] => {
  const selectedOptions: DriverDeployabilityOption[] = [];

  for (const deployabilityOption of deployabilityOptions) {
    const found = findDriverToDeployabilityOption(
      driverToDeployabilityOptions,
      deployabilityOption
    );
    if (found) {
      selectedOptions.push(found);
    }
  }

  return selectedOptions;
};

export const hasDriverSelectedAllOptionsForADay = (
  driverToDeployabilityOptions: DriverDeployabilityOption[],
  deployabilityOptions: DeployabilityOption[]
) => {
  for (const deployabilityOption of deployabilityOptions) {
    const found = findDriverToDeployabilityOption(
      driverToDeployabilityOptions,
      deployabilityOption
    );
    if (!found) {
      return false;
    }
  }

  return true;
};
